export default __webpack_public_path__ + "static/media/factory__57.abc6c2a1.jpg";